import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class ContractService {

    private baseUrl: string = '../rest/company';
    constructor (
        private http: Http
    ) {}

    get(id) {
        return this.http.get(`${this.baseUrl}/${id}/contract`)
            .map((res:any) => res.json());
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/core/contract.service.ts